// Search boxes select their whole text when you click into them, so you can type a new
// search straight away (Ben's #187) — main.js's page-wide handler, 1:1 (05j-2). One set of
// document listeners covers every box, including ones rendered later.
//
// Safari needs the mouseup part: the click that focuses the box selects the text, but the
// mouseup that follows would drop the caret where you clicked and wipe the selection — so
// that ONE mouseup is ignored. A later click, once you're already in the box, places the
// caret normally. (Not the Notes title: that's text you edit, not a search.)

export const SELECT_ALL_ON_CLICK = [
  ".player-search",
  "#module-search",
  "#mobile-sheet-search",
  ".styled-select-search",
  ".value-picker-search",
  ".ranking-player-search",
  ".zone-name-search",
  ".radar-axis-editor-search",
].join(", ");

const isSearchBox = (t: EventTarget | null): t is HTMLInputElement =>
  t instanceof HTMLInputElement && t.matches(SELECT_ALL_ON_CLICK);

/** Installed just before main.js loads, where main.js added these listeners. */
export function installSelectAllOnClick(): void {
  let focusedByThisClick: HTMLInputElement | null = null;
  document.addEventListener("focusin", (e) => {
    if (isSearchBox(e.target)) e.target.select();
  });
  document.addEventListener(
    "mousedown",
    (e) => {
      const t = e.target;
      focusedByThisClick = isSearchBox(t) && document.activeElement !== t ? t : null;
    },
    true,
  );
  document.addEventListener(
    "mouseup",
    (e) => {
      if (focusedByThisClick && e.target === focusedByThisClick) e.preventDefault();
      focusedByThisClick = null;
    },
    true,
  );
}
